var NKTEN_DISABLE_ANIMATIONS = true;

document.addEventListener('DOMContentLoaded', initTestimonialsNkten);
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initTestimonialsNkten);
}

function initTestimonialsNkten(event) {
  const root = event && event.target && event.target.querySelector
    ? event.target.querySelector('[data-testimonials-nkten]')
    : document.querySelector('[data-testimonials-nkten]');

  const sections = root ? [root] : document.querySelectorAll('[data-testimonials-nkten]');

  sections.forEach((section) => {
    if (!section || section.dataset.testimonialsInitialized) return;
    section.dataset.testimonialsInitialized = 'true';

    const track = section.querySelector('[data-testimonials-track]');
    const prevBtn = section.querySelector('[data-testimonials-prev]');
    const nextBtn = section.querySelector('[data-testimonials-next]');

    if (track && prevBtn && nextBtn) {
      const scrollByAmount = () => {
        const slide = track.querySelector('.testimonials-nkten__slide');
        return slide ? slide.getBoundingClientRect().width + 24 : track.clientWidth;
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
      });
    }

    const slides = section.querySelectorAll('.testimonials-nkten__slide');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (NKTEN_DISABLE_ANIMATIONS || prefersReducedMotion || !window.gsap || !window.ScrollTrigger) {
      slides.forEach((s) => { s.style.opacity = '1'; s.style.transform = 'none'; });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    gsap.set(slides, { opacity: 0, y: 24 });

    gsap.to(slides, {
      opacity: 1,
      y: 0,
      duration: 0.7,
      ease: 'expo.out',
      stagger: 0.1,
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        once: true,
      },
    });
  });
}
